export function Settings() {
  return (
    <s-page heading="Settings">
      <header className="page-header">
        <div>
          <s-paragraph>Control app status, cache behavior, privacy links, and cleanup notes.</s-paragraph>
        </div>
        <s-button variant="primary">Save settings</s-button>
      </header>
      <s-section heading="App configuration">
        <div className="form-grid">
          <label>
            App status
            <select defaultValue="active">
              <option value="active">Active</option>
              <option value="paused">Paused</option>
            </select>
          </label>
          <label>
            App embed status
            <input readOnly value="Needs merchant confirmation in theme editor" />
          </label>
          <label>
            Cache status
            <input readOnly value="Warm" />
          </label>
          <label>
            Fallback behavior
            <select defaultValue="fail_open">
              <option value="fail_open">Fail open to checkout</option>
              <option value="no_offers">Show no offers</option>
            </select>
          </label>
          <label>
            Privacy policy URL
            <input placeholder="https://upsell.ecommapp.cloud/privacy" />
          </label>
          <label>
            Uninstall cleanup
            <textarea readOnly value="On uninstall, webhooks queue token deletion, runtime cache purge, and retention-window event cleanup." />
          </label>
        </div>
      </s-section>
    </s-page>
  );
}
